export class Identifier {
  private readonly _value?: string;

  constructor(value?: string) {
    if (value && (value.length < 2 || value.length > 255)) {
      throw new Error("Identifier must be between 2 and 255 characters");
    }

    this._value = value;
  }

  toString(): string {
    return this._value ?? "";
  }
}
